"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeLogin = exports.startLogin = exports.signUp = exports.currentAuthToken = exports.currentUser = exports.signOut = void 0;
var auth_1 = require("@aws-amplify/auth");
var amazon_cognito_identity_js_1 = require("amazon-cognito-identity-js");
var loginSessionKey = "homebound-start-login-session";
var CognitoHomeboundUser = /** @class */ (function () {
    function CognitoHomeboundUser(user) {
        this.user = user;
    }
    Object.defineProperty(CognitoHomeboundUser.prototype, "name", {
        get: function () {
            return this.user.attributes.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CognitoHomeboundUser.prototype, "email", {
        get: function () {
            return this.user.attributes.email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CognitoHomeboundUser.prototype, "phone", {
        get: function () {
            return this.user.attributes.phone_number;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CognitoHomeboundUser.prototype, "picture", {
        get: function () {
            return this.user.attributes.picture;
        },
        enumerable: false,
        configurable: true
    });
    return CognitoHomeboundUser;
}());
function signOut() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, auth_1.Auth.signOut()];
        });
    });
}
exports.signOut = signOut;
/**
 * Returns the current logged-in user according to amplify.
 */
function currentUser() {
    return __awaiter(this, void 0, void 0, function () {
        var u, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, auth_1.Auth.currentAuthenticatedUser()];
                case 1:
                    u = _a.sent();
                    return [2 /*return*/, { data: new CognitoHomeboundUser(u) }];
                case 2:
                    e_1 = _a.sent();
                    if (userNotLoggedIn(e_1)) {
                        return [2 /*return*/, { data: undefined }];
                    }
                    return [2 /*return*/, toError(e_1)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.currentUser = currentUser;
function currentAuthToken() {
    return __awaiter(this, void 0, void 0, function () {
        var session, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, auth_1.Auth.currentSession()];
                case 1:
                    session = _a.sent();
                    return [2 /*return*/, session.getIdToken().getJwtToken()];
                case 2:
                    e_2 = _a.sent();
                    // not logged in or other auth error
                    if (!userNotLoggedIn(e_2)) {
                        console.log(e_2);
                    }
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.currentAuthToken = currentAuthToken;
function signUp(_a) {
    var name = _a.name, email = _a.email, phone = _a.phone;
    return __awaiter(this, void 0, void 0, function () {
        var params;
        return __generator(this, function (_b) {
            params = {
                username: email,
                // cognito requires a password even though we don't use it
                password: getRandomString(30),
                attributes: {
                    name: name,
                    email: email,
                    phone_number: phone,
                },
            };
            return [2 /*return*/, auth_1.Auth.signUp(params).then(function () {
                    return startLogin(email);
                }, function (e) { return toError(e); })];
        });
    });
}
exports.signUp = signUp;
function startLogin(email) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, auth_1.Auth.signIn(email).then(function (user) {
                    localStorage.setItem(loginSessionKey, JSON.stringify({
                        email: email,
                        session: user.Session,
                    }));
                    return { data: user };
                }, function (e) { return toError(e); })];
        });
    });
}
exports.startLogin = startLogin;
function completeLogin(config, token) {
    return __awaiter(this, void 0, void 0, function () {
        var data, loginSession, user;
        var _this = this;
        return __generator(this, function (_a) {
            data = localStorage.getItem(loginSessionKey);
            if (data === null) {
                return [2 /*return*/, Promise.resolve(toError({ code: "Missing User Session", message: "" }))];
            }
            loginSession = JSON.parse(data);
            user = new auth_1.CognitoUser({
                Username: loginSession.email,
                Pool: new amazon_cognito_identity_js_1.CognitoUserPool({
                    UserPoolId: config.Auth.userPoolId,
                    ClientId: config.Auth.userPoolWebClientId,
                }),
            });
            // we need to rehydrate the client Session info from localStorage
            // but there's not a good way to do this with amplify...
            user["Session"] = loginSession.session;
            user.setAuthenticationFlowType("CUSTOM_AUTH");
            return [2 /*return*/, auth_1.Auth.sendCustomChallengeAnswer(user, token).then(function () { return __awaiter(_this, void 0, void 0, function () {
                    var u;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                localStorage.removeItem(loginSessionKey);
                                return [4 /*yield*/, auth_1.Auth.currentAuthenticatedUser()];
                            case 1:
                                u = _a.sent();
                                return [2 /*return*/, { data: new CognitoHomeboundUser(u) }];
                        }
                    });
                }); }, function (e) { return toError(e); })];
        });
    });
}
exports.completeLogin = completeLogin;
function userNotLoggedIn(err) {
    return err === "No current user";
}
function toError(e) {
    return { data: undefined, error: { code: e.code, message: e.message } };
}
function getRandomString(bytes) {
    var randomValues = new Uint8Array(bytes);
    window.crypto.getRandomValues(randomValues);
    return Array.from(randomValues).map(intToHex).join("");
}
function intToHex(nr) {
    return nr.toString(16).padStart(2, "0");
}
//# sourceMappingURL=auth-utils.js.map